const FeeGuideAccordion = {
	init() {
		// Initialize property-level accordions (fee-guide-wrapper)
		this.initPropertyAccordions();
		
		// Initialize fee-item accordions
		this.initFeeItemAccordions();
	},

	initPropertyAccordions() {
		// Find all community fee guide wrappers
		const communityWrappers = document.querySelectorAll('.community-fee-guide-wrapper');
		
		communityWrappers.forEach((communityWrapper) => {
			// Check if there's only one fee-guide-wrapper inside this community wrapper
			const feeGuideWrappers = communityWrapper.querySelectorAll('.fee-guide-wrapper');
			
			// Only make accordions if there are multiple fee-guide-wrapper elements
			if (feeGuideWrappers.length > 1) {
				this.makePropertyAccordions(feeGuideWrappers);
			} else if (feeGuideWrappers.length === 1) {
				// For single property, expand the description by default and remove accordion functionality
				const wrapper = feeGuideWrappers[0];
				const description = wrapper.querySelector('.fee-guide-description');
				if (description) {
					wrapper.classList.add('active');
					description.style.maxHeight = 'none';
					description.style.opacity = '1';
					// description.style.padding = '0px 0 20px';
				}
				// Add class to community wrapper to indicate single property
				communityWrapper.classList.add('single-property');
			}
		});
	},

	makePropertyAccordions(feeGuideWrappers) {
		// Add click event listeners to each property section
		feeGuideWrappers.forEach((wrapper) => {
			const heading = wrapper.querySelector('.fee-guide-heading');
			const description = wrapper.querySelector('.fee-guide-description');
			
			if (heading && description) {
				// Add cursor pointer to heading
				heading.style.cursor = 'pointer';
				
				// Add click event listener
				heading.addEventListener('click', () => {
					// Toggle active class on wrapper
					wrapper.classList.toggle('active');
				});
				
				// Add keyboard support for accessibility
				heading.addEventListener('keydown', (e) => {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						heading.click();
					}
				});
				
				// Make heading focusable for accessibility
				heading.setAttribute('tabindex', '0');
				heading.setAttribute('role', 'button');
				heading.setAttribute('aria-expanded', 'false');
				heading.setAttribute('aria-controls', description.id || 'fee-guide-description');
			}
		});
		
		// Update aria-expanded attributes when property sections are toggled
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
					const wrapper = mutation.target;
					const heading = wrapper.querySelector('.fee-guide-heading');
					const isActive = wrapper.classList.contains('active');
					
					if (heading) {
						heading.setAttribute('aria-expanded', isActive.toString());
					}
				}
			});
		});
		
		feeGuideWrappers.forEach((wrapper) => {
			observer.observe(wrapper, { attributes: true });
		});
	},

	initFeeItemAccordions() {
		// Find all fee guide sections
		const feeItems = document.querySelectorAll('.fee-item');
		
		if (feeItems.length === 0) {
			return;
		}

		// Add click event listeners to each fee item
		feeItems.forEach((item) => {
			const question = item.querySelector('h3');
			const content = item.querySelector('.fee-content');
			
			if (question && content) {
				// Add cursor pointer to question
				question.style.cursor = 'pointer';
				
				// Add click event listener
				question.addEventListener('click', () => {
					// Toggle active class on item
					item.classList.toggle('active');
				});
				
				// Add keyboard support for accessibility
				question.addEventListener('keydown', (e) => {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						question.click();
					}
				});
				
				// Make question focusable for accessibility
				question.setAttribute('tabindex', '0');
				question.setAttribute('role', 'button');
				question.setAttribute('aria-expanded', 'false');
				question.setAttribute('aria-controls', content.id || 'fee-content');
			}
		});
		
		// Update aria-expanded attributes when items are toggled
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
					const item = mutation.target;
					const question = item.querySelector('h3');
					const isActive = item.classList.contains('active');
					
					if (question) {
						question.setAttribute('aria-expanded', isActive.toString());
					}
				}
			});
		});
		
		feeItems.forEach((item) => {
			observer.observe(item, { attributes: true });
		});
	},
};

export default FeeGuideAccordion;
